import React, { Fragment, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import AxisSpinner from "../components/AxisSpinner";
import ShiftShiftStatusElement from "../components/ShiftShiftStatusElement";
import ShiftShiftDetailsElement from "../components/ShiftShiftDetailsElement";
import ShiftAssociatedBookingElement from "../components/ShiftAssociatedBookingElement";
import ShiftAuditTrailElement from "../components/ShiftAuditTrailElement";
import ShiftCancellationsElement from "../components/ShiftCancellationsElement";
import { Col, Container, Row } from "react-bootstrap";
import { BsCalendarWeekFill } from "react-icons/bs";
import { AxisLineSeparator } from "../components/AxisLineSeparator";
import {
  ButtonApproveShift,
  ButtonAssignShift,
  ButtonCancelShift,
  ButtonDenyCancelShift,
  ButtonDenyReopenShift,
  ButtonEditShift,
  ButtonPendingShift,
  ButtonReassignShift,
  ButtonReopenShift,
  ButtonSendShiftReminder,
} from "../components/ShiftShiftButtonActionsElements";
import ShiftAvailabilityMatchesElement from "../components/ShiftAvailabilityMatchesElement";
import ShiftCreateUpdateModal from "../modals/ShiftCreateUpdateModal";
import AssignShiftModal from "../modals/AssignShiftModal";
import CancelShiftModal from "../modals/CancelShiftModal";
import ShiftReminderModal from "../modals/ShiftReminderModal";

const ActiveShift = () => {
  const { authAxios } = useAuth();
  const { shiftId } = useParams();
  const [loading, setLoading] = useState(true);
  const [shift, setShift] = useState(null);
  const [showShiftCreate, setShowShiftCreate] = useState(false);
  const [showAssignShift, setShowAssignShift] = useState(false);
  const [showCancelShift, setShowCancelShift] = useState(false);
  const [showShiftReminder, setShowShiftReminder] = useState(false);
  const [cancelAction, setCancelAction] = useState("CANCEL");
  const [isPending, setPending] = useState(false);

  useEffect(() => {
    document.title = "Shift";

    if (shift === null || shift === undefined) {
      fetch();
    }

    let timer = setInterval(() => {
      const modalsOpened =
        showShiftCreate ||
        showAssignShift ||
        showCancelShift ||
        showShiftReminder;

      if (!modalsOpened) fetch();
    }, 10000);
    return () => clearInterval(timer);
  }, [
    shift,
    showShiftCreate,
    showAssignShift,
    showCancelShift,
    showShiftReminder,
  ]);

  const fetch = async () => {
    try {
      setLoading(true);

      var params = {
        shift_id: shiftId,
      };

      const config = {
        headers: {
          "content-type": "application/json",
        },
        params: params,
      };

      const response = await authAxios().get(
        "/api/backoffice/shifts/active",
        config,
      );
      setLoading(false);

      setShift(response.data);
    } catch (error) {
      setLoading(false);
      console.log("Error catch");
      console.log(error);
      console.log(error.stack);
    }
  };

  useEffect(() => {
    fetch();
  }, []);

  const SpinnerOrData = (loading) => {
    if (loading && shift === null) return <AxisSpinner loading={loading} />;

    return (
      <Container fluid>
        <Row>
          <Col>
            <div>
              <ShiftShiftStatusElement shift={shift} />
            </div>
            <AxisLineSeparator />
            <div>
              <ShiftShiftDetailsElement shift={shift} />
            </div>
            <AxisLineSeparator />
            <div>
              <ShiftAuditTrailElement shift={shift} />
            </div>
          </Col>
          <Col>
            <div>
              <ShiftAssociatedBookingElement shift={shift} />
            </div>
            <div>
              <ShiftAvailabilityMatchesElement shift={shift} />
            </div>
            <div>
              <ShiftCancellationsElement shift={shift} />
            </div>
          </Col>
        </Row>
        {loading ? <AxisSpinner loading={loading} /> : null}
      </Container>
    );
  };

  return (
    <Fragment>
      <Row className={"icon-text-wrapper"}>
        <Col>
          <h1 className={"text-axis-offblack icon-text-wrapper"}>
            <BsCalendarWeekFill /> View Shift: {shift?.notificationId}
          </h1>
        </Col>
        <Col>
          <Container className={"m-0 p-0"}>
            <Row xs={"auto"} className={"justify-content-end shift-button"}>
              <ButtonSendShiftReminder
                shift={shift}
                action={() => {
                  setShowShiftReminder(true);
                }}
              />
              <ButtonDenyReopenShift
                shift={shift}
                action={() => {
                  setCancelAction("REOPEN");
                  setShowCancelShift(true);
                }}
              />
              <ButtonDenyCancelShift
                shift={shift}
                action={() => {
                  setCancelAction("CANCEL");
                  setShowCancelShift(true);
                }}
              />
              <ButtonReopenShift
                shift={shift}
                action={() => {
                  setCancelAction("REOPEN");
                  setShowCancelShift(true);
                }}
              />
              <ButtonCancelShift
                shift={shift}
                action={() => {
                  setCancelAction("CANCEL");
                  setShowCancelShift(true);
                }}
              />
              <ButtonPendingShift
                shift={shift}
                action={() => {
                  setPending(true);
                  setShowAssignShift(true);
                }}
              />
              <ButtonReassignShift
                shift={shift}
                action={() => {
                  setPending(false);
                  setShowAssignShift(true);
                }}
              />
              <ButtonAssignShift
                shift={shift}
                action={() => {
                  setPending(false);
                  setShowAssignShift(true);
                }}
              />
              <ButtonApproveShift
                shift={shift}
                action={() => {
                  setPending(false);
                  setShowAssignShift(true);
                }}
              />
              <ButtonEditShift
                shift={shift}
                action={() => {
                  setShowShiftCreate(true);
                }}
              />
            </Row>
          </Container>
        </Col>
      </Row>
      <AxisLineSeparator />

      {SpinnerOrData(loading)}

      <ShiftCreateUpdateModal
        visible={showShiftCreate}
        close={() => setShowShiftCreate(false)}
        shift={shift}
        updateShift={setShift}
      />
      <AssignShiftModal
        visible={showAssignShift}
        close={() => setShowAssignShift(false)}
        shift={shift}
        updateShift={setShift}
        pending={isPending}
      />
      <CancelShiftModal
        visible={showCancelShift}
        close={() => setShowCancelShift(false)}
        shift={shift}
        updateShift={setShift}
        cancelAction={cancelAction}
      />
      <ShiftReminderModal
        visible={showShiftReminder}
        close={() => setShowShiftReminder(false)}
        shift={shift}
        updateShift={setShift}
      />
    </Fragment>
  );
};

export default ActiveShift;
